var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-8 col-12" }, [
        _c("h2", { staticClass: "mb-2" }, [
          _vm._v(_vm._s(_vm.$t("message.menu.invite_friends")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "text-comment" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t("message.invite_friends.receive_credit_detail", {
                  credits: _vm.globalState.configData.invite_friend_credits
                })
              ) +
              "\n      "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-4 no-gutters" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("label", [
              _vm._v(_vm._s(_vm.$t("message.invite_friends.share_your_link")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-fill" }, [
              _c("input", {
                ref: "referralCode",
                staticClass: "form-control flex-fill",
                attrs: { type: "text" },
                domProps: {
                  value:
                    "beneat.co/chat-booking?c=" + _vm.referralCode.referral_code
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "clipboard",
                        rawName: "v-clipboard:copy",
                        value: _vm.referralCode.url_referral_code,
                        expression: "referralCode.url_referral_code",
                        arg: "copy"
                      }
                    ],
                    staticClass: "btn btn-info",
                    on: { click: _vm.copyReferralCode }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t(_vm.isCopiedReferralCode)) +
                        "\n              "
                    )
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "my-3" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-block -indigo my-2",
                  attrs: {
                    href:
                      "https://www.facebook.com/sharer/sharer.php?u=" +
                      _vm.referralCode.url_referral_code,
                    target: "_blank"
                  }
                },
                [
                  _c("i", { staticClass: "fab fa-facebook-f mr-3" }),
                  _vm._v(" Share on Facebook\n            ")
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-3" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-block -blue my-2",
                  attrs: {
                    href:
                      "https://twitter.com/intent/tweet?url=" +
                      _vm.referralCode.url_referral_code,
                    target: "_blank"
                  }
                },
                [
                  _c("i", { staticClass: "fab fa-twitter mr-3" }),
                  _vm._v(" Share on Twitter\n            ")
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4 col-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body shadow-sm" }, [
            _c("div", { staticClass: "row no-gutters text-remark text-dark" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("h3", [
                  _vm._v(_vm._s(_vm.$t("message.credit.your_credits")))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 text-info" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("message.credit.pending_status")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 text-right" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.user.pendingCredits)))
                ])
              ]),
              _vm._v(" "),
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-8 text-info" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(_vm.$t("message.credit.available_status")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4 text-right" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm._f("currency")(_vm.user.totalCredits)))
                ])
              ]),
              _vm._v(" "),
              _vm._m(3),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "btn btn-block btn-info",
                      attrs: { to: "/user/credits" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t("message.invite_friends.view_transactions")
                          ) +
                          "\n              "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "mt-4" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("message.invite_friends.how_do_invites_work")))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mt-5" }, [
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _vm._m(4),
          _vm._v(" "),
          _c("h4", [
            _vm._v(
              _vm._s(
                _vm.$t("message.invite_friends.how_do_invites_work_title01")
              )
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-comment" }, [
            _vm._v(
              _vm._s(
                _vm.$t("message.invite_friends.how_do_invites_work_detail01")
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("h4", [
            _vm._v(
              _vm._s(
                _vm.$t("message.invite_friends.how_do_invites_work_title02", {
                  credits: _vm.globalState.configData.register_credits
                })
              )
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-comment" }, [
            _vm._v(
              _vm._s(
                _vm.$t("message.invite_friends.how_do_invites_work_detail02", {
                  credits: _vm.globalState.configData.register_credits
                })
              )
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-sm-4" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("h4", [
            _vm._v(
              _vm._s(
                _vm.$t("message.invite_friends.how_do_invites_work_title03", {
                  credits: _vm.globalState.configData.invite_friend_credits
                })
              )
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "text-comment" }, [
            _vm._v(
              _vm._s(
                _vm.$t("message.invite_friends.how_do_invites_work_detail03", {
                  credits: _vm.globalState.configData.invite_friend_credits
                })
              )
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-4" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-3" }, [
      _c("i", { staticClass: "fal fa-piggy-bank fa-2x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4" }, [
      _c("i", { staticClass: "fal fa-link fa-3x -status-pending" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4" }, [
      _c("i", { staticClass: "fal fa-hand-holding-usd fa-3x -status-new" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mb-4" }, [
      _c("i", { staticClass: "fal fa-piggy-bank fa-3x -status-new" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-509b0d8d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509b0d8d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Invite.vue
// module id = 1923
// module chunks = 0